export function withHttp(prevURL) {
  let url = prevURL?.trim()
  if (!url) {
    return ""
  } else if (!/^https?:\/\//i.test(url)) {
    url = "http://" + url
  }
  return url
}
